<template lang='pug'>
	.contenido-2-columnas-A
		.contenedor-contenido-2-columnas
			.contenido
				.modulo
					h1
						| Why pay an energy consultant for typing information into a computer?
					p.caja-texto1
							| You pay an energy consultant for his knowledge, not for his typing speed. Our Do-It-Yourself 'take-off' tools enable you to input information on your residential building design, and submit this information to our Title 24 consultants for fast turnarounds at
							router-link(to='/compliance-wizard')
								span: |  deeply discounted prices!
				.modulo
					p
						| Using the Do-It-Yourself Takeoff Tools is simple: all you need to get started is to provide a user name, a valid email and a password, and you are ready to create your first project.
						app-link(:to="navLinks.newProject")
							span
								| Take a test drive, create a new Project!
					p
						| If you have already created a project, you can click 'Edit Active Project' on the green menu toolbar, and you will be taken to the section of the active project that you were editing last.
</template>

<script>
export default {
	name: 'Twocolumns',
	data: function () {
		return {
			navLinks: {}
		}
	},
	beforeMount: function () {
		this.navLinks = this.$e24Common.storageService.findItem('navLinks', true)
		// console.debug('NavBar config', this.navLinks)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/doit/contentTwoColumns.vue